import gql from 'graphql-tag';

import client from '../graphqlAPI';

const EDIT_EMAIL_TEMPLATE_MUTATION = gql`
  mutation editEmailTemplate($id: String, $templateId: String!, $name: String!, $language: String!, $scope: String!, $subject: String!, $preheader: String, $htmlContent: String!, $textContent: String, $sampleDataJson: String, $blocksJson: String, $needsReview: Boolean, $isActive: Boolean, $appName: String) {
    editEmailTemplate(id: $id, templateId: $templateId, name: $name, language: $language, scope: $scope, subject: $subject, preheader: $preheader, htmlContent: $htmlContent, textContent: $textContent, sampleDataJson: $sampleDataJson, blocksJson: $blocksJson, needsReview: $needsReview, isActive: $isActive, appName: $appName) {
      isAuth
      success
      error
      template {
        _id
        templateId
        name
        language
        scope
        subject
        preheader
        htmlContent
        textContent
        sampleData
        blocks
        needsReview
        variables
        isActive
        source
        appName
        updatedAt
        revisions {
          subject
          preheader
          htmlContent
          textContent
          sampleData
          author
          savedAt
        }
      }
    }
  }
`;

// `blocksJson` is the block document as a JSON string, sent together with the
// `htmlContent` the client generated from it with renderBlocks(). Both in one
// mutation, from one action, on purpose: the serialiser is a frontend module
// and a second implementation server-side would drift. Omitting blocksJson
// (every save from the non-block path) says nothing about blocks and leaves
// whatever is stored alone — there is deliberately no way to clear a block
// document through this call.
const editEmailTemplate = async ({
  id, templateId, name, language, scope, subject, preheader, htmlContent, textContent,
  sampleDataJson, blocksJson, needsReview, isActive, appName,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: EDIT_EMAIL_TEMPLATE_MUTATION,
        variables: {
          id,
          templateId,
          name,
          language,
          scope,
          subject,
          preheader,
          htmlContent,
          textContent,
          sampleDataJson,
          blocksJson,
          needsReview,
          isActive,
          appName,
        },
        fetchPolicy: 'no-cache',
      })
      .then(mutationResult => mutationResult)
      .catch((mutationError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Mutation Error: ${mutationError}`);
        return null;
      });

    const { data: { editEmailTemplate: editEmailTemplateData } } = result;

    if (editEmailTemplateData) return editEmailTemplateData;

    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Mutation Error: editEmailTemplateData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: editEmailTemplate Error: ${error}`);
    return null;
  }
};

export default editEmailTemplate;
